// extracted by mini-css-extract-plugin
export default {"open":"Sidebar_open__38Z8B"};